import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`By the end of 2019, WFP was responding to pressing food needs in seven highest-level emergencies, also known as Level 3 (L3) Emergencies: the Democratic Republic of the Congo, Northeast Nigeria, the Central Sahel, South Sudan, Syria, Yemen and Mozambique. Continuous support from the EU ensured a lifeline for millions of people in these countries.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      